import { MessageWithActionAndData } from "@me8eon/sessions_messages";

const extractAllSources = (rawString: string) => {
    if (!rawString) return [];

    const results = [];

    const regex =
        /Index:\s*(.+?)\s*[\r\n]+[\s\S]*?Source:\s+"""([\s\S]*?)"""/g;

    let match;

    while ((match = regex.exec(rawString)) !== null) {
        try {
            const indexName = match[1].trim();
            const data = JSON.parse(match[2]);

            results.push({
                index: indexName,
                id: data.number
            });
        } catch (e) {
            console.error("Failed to parse one source block:", e);
        }
    }

    return results;
};

export const getLastObj = (
    msgs: MessageWithActionAndData[],
    role: string,
    containsText?: string
): { message: MessageWithActionAndData; index: number } | null => {
    for (let i = msgs.length - 1; i >= 0; i--) {
        const m = msgs[i];

        if (m.role !== role) continue;

        if (
            containsText &&
            (typeof m.content !== "string" ||
                !m.content.includes(containsText))
        ) {
            continue;
        }

        return {
            message: m,
            index: i
        };
    }

    return null;
};

export const getSources = (msgs: any[]) => {
    const lastUserObj = getLastObj(msgs, "user")
    const userIndex = lastUserObj?.index || -1;
    const toolObj = getLastObj(msgs, "tool", "Here are the top 5 documents")
    const toolIndex = toolObj?.index || -1;
    if (toolIndex > userIndex) {
        const sourceObjArray = extractAllSources(JSON.parse(msgs[toolIndex].content).value)
        return sourceObjArray.slice(0, 3);
    }
    return [];
}

export const isWidgetMessage = (content: string): boolean => {
    try {
        const parsed = JSON.parse(content);
        return parsed?._meta?.widget?.type === 'widget';
    } catch {
        return false;
    }
}
